module.exports = __webpack_public_path__ + "static/media/chef_hat.287baf83.svg";